import { Injectable } from '@angular/core'
import mixpanel from 'mixpanel-browser'

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {

  init(): void {
    let initOptions : Partial<any> = {
      track_pageview: false,
      persistence: 'localStorage',
    }

    if (window.location.hostname === 'localhost') {
      initOptions['debug'] = true
      // initOptions.api_host = window.origin
    } else {
      initOptions['api_host'] = window.origin
    }

    mixpanel.init('7a471336a8f3369e0e427332b037e638', initOptions)


  }
  identify(userToken: string): void {
    mixpanel.identify(userToken)
  }

  addGroup(groupKey: string, groupID: string) {
    mixpanel.add_group(groupKey, groupID)
  }

  track(id: string, action: any = {}): void {
    mixpanel.track(id, action)
  }
  trackPageView(args:any = {}) {
    mixpanel.track_pageview(args)
  }

  reset() {
    mixpanel.reset()
  }
}